<template>
    <div>
        <Header/>
        <section class="section">
            <div class="container">
                <h1 class="title">
                    {{ laptop_type.name}}
                    <span v-if="laptop_type.slug === 'universalnye' || laptop_type.slug === 'igrovye'">Ноутбуки </span>
                    в Ташкенте
                </h1>
                <div class="field is-pulled-right">
                    <div class="control">
                        <span>Сортировка: </span>
                        <span :class="['tag', {'is-success' : sorting.isSorted}]" @click="sortLaptops">{{ sorting.price_text}}</span>
                    </div>
                </div>
            </div>
        </section>
        <div class="container">
            <ProductsGrid :laptops="laptops" :columnWidth="6"/>
        </div>
        <section class="has-text-centered">
            <button v-if="next_page" class="button is-warning is-outlined is-large" @click="loadMore">Загрузить еще...
            </button>
        </section>
    </div>
</template>
<script>
    import Header from "../../components/header/HeaderBF";
    import BreadCrumb from "../../components/BreadCrumb";
    import ProductCard from "../../components/products/ProductCard";
    import ProductsGrid from "../../components/products/ProductsGrid";
    import axios from 'axios'
    import TopBar from "../../components/header/TopBar";
    import {API_URL} from "../../../main";

    export default {
        name: "ProductsByType",
        components: {TopBar, ProductsGrid, ProductCard, BreadCrumb, Header},
        inject: ['toastWarning', 'openLoading', 'closeLoading'],
        props: {
            type: {}
        },
        data() {
            return {
                sorting: {
                    isSorted: false,
                    price_text: 'Цена',
                },
                laptop_type: [],
                laptops: [],
                paging: {
                    count: Number,
                    limit: 10,
                    offset: 0
                },
                ordering: 'price_year',
                available_stock: true
            }
        },
        methods: {
            fetchType() {
                this.openLoading()
                axios.get(API_URL + '/laptop-types', {
                    params: {
                        slug: this.type
                    }
                })
                    .then(response => {
                        this.laptop_type = response.data[0];
                        this.fetchLaptops()
                    })
            },
            fetchLaptops() {
                axios.get(API_URL + '/laptops', {
                    params: {
                        type: this.laptop_type.id,
                        limit: this.paging.limit,
                        offset: this.paging.offset,
                        active: this.available_stock,
                        ordering: this.ordering
                    }
                })
                    .then(response => {
                        this.closeLoading()
                        this.laptops = this.laptops.concat(response.data.results);
                        this.next_page = response.data.next
                    })
            },
            loadMore() {
                this.paging.offset += 10;
                this.fetchLaptops()
            },
            sortLaptops() {
              if (this.ordering === 'price_year') {
                this.ordering = '-price_year';
                this.sorting.price_text = 'От дорогих к дешевым'
              } else {
                this.ordering = 'price_year';
                this.sorting.price_text = 'От дешевых к дорогим'
              }
                this.sorting.isSorted = true;
                this.laptops = [];
                this.paging.offset = 0;
                this.fetchLaptops()
            }
        },
        created () {
            this.fetchType()
        }
    }
</script>
<style scoped>

</style>